import { atom } from 'recoil';

export const customGradesState = atom({
  key: 'customGradesState',
  default: {},
});